/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DoubleOrInfinity
 */
export interface DoubleOrInfinity {
    /**
     * ('Infinity', '-Infinity'). Mutually exclusive with value.
     * @type {string}
     * @memberof DoubleOrInfinity
     */
    specialValue?: DoubleOrInfinitySpecialValueEnum;
    /**
     * The finite numeric value, if the edge is finite. Mutually exclusive with specialValue.
     * @type {number}
     * @memberof DoubleOrInfinity
     */
    value?: number;
}


/**
 * @export
 */
export const DoubleOrInfinitySpecialValueEnum = {
    MinusInfinity: 'MINUS_INFINITY',
    Infinity: 'INFINITY'
} as const;
export type DoubleOrInfinitySpecialValueEnum = typeof DoubleOrInfinitySpecialValueEnum[keyof typeof DoubleOrInfinitySpecialValueEnum];


/**
 * Check if a given object implements the DoubleOrInfinity interface.
 */
export function instanceOfDoubleOrInfinity(value: object): value is DoubleOrInfinity {
    return true;
}

export function DoubleOrInfinityFromJSON(json: any): DoubleOrInfinity {
    return DoubleOrInfinityFromJSONTyped(json, false);
}

export function DoubleOrInfinityFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoubleOrInfinity {
    if (json == null) {
        return json;
    }
    return {
        
        'specialValue': json['specialValue'] == null ? undefined : json['specialValue'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function DoubleOrInfinityToJSON(value?: DoubleOrInfinity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'specialValue': value['specialValue'],
        'value': value['value'],
    };
}

